module.exports = __webpack_public_path__ + "static/jeanine-010-7e1897ded08ad54a8a87738506168e4c.jpg";